import React, {useEffect} from 'react';
import FooterComponent from '../components/home/FooterComponent.js';
import BookCallComponent from '../components/signUp/BookCallComponent.js';

//Imports assets such as images
import {sendSlackMessage} from "../models/notifications";
import LogoTicker from "../components/signUp/logoTicker";
import ScrollableFeedComponent from "../components/generalComponents/scrollableFeedComponent";



export default function BookCallPage() {
    useEffect(() => {
        sendSlackMessage("Visitor is visiting the Signup page", "#website-updates")
    }, [])

    return (
        <div>
            <div className="updated-page-wrapper">
                <div style={{
                    minHeight: "100vh",
                    background: "#faf2eb"
                }}>
                    <BookCallComponent />
                    <LogoTicker />
                    <ScrollableFeedComponent type="blogs" />
                </div>

                <FooterComponent />

            </div>
        </div>

    );
}

